module.exports = __webpack_public_path__ + "img/arrow-l.d7cb1060.svg";